// Human-readable date/time formatting
export function formatDateTime(iso, locale = "en-GB") {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString(locale, {
      day: "2-digit", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch (_) { return "—"; }
}

export function formatDate(iso, locale = "en-GB") {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString(locale, { day: "2-digit", month: "short", year: "numeric" });
  } catch (_) { return "—"; }
}

export function timeAgo(iso, lang = "en") {
  if (!iso) return "—";
  const t = new Date(iso).getTime();
  const diff = Math.max(0, Date.now() - t);
  const min = Math.round(diff / 60000);
  const hr = Math.round(diff / 3600000);
  const day = Math.round(diff / 86400000);
  const wk = Math.round(day / 7);
  const en = { now: "just now", min: "min ago", hr: "hr ago", day: "d ago", wk: "wk ago" };
  const tr = { now: "az önce", min: "dk önce", hr: "sa önce", day: "gün önce", wk: "hafta önce" };
  const L = lang === "tr" ? tr : en;
  if (min < 1) return L.now;
  if (min < 60) return `${min} ${L.min}`;
  if (hr < 24) return `${hr} ${L.hr}`;
  if (day < 14) return `${day} ${L.day}`;
  return `${wk} ${L.wk}`;
}
